import {
  Button,
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogProps,
  DialogTitle,
  SubmitButton,
} from '@fortem-monorepo/react-ui'

import { AddShareclassForm } from '@/components/forms/AddShareclassForm/AddShareclassForm'
import { AddShareclassFormFields } from '@/components/forms/AddShareclassForm/AddShareclassFormFields'

export interface AddShareclassModalProps extends DialogProps {}

export const AddShareclassModal: React.FC<AddShareclassModalProps> = ({ ...props }) => {
  return (
    <Dialog {...props}>
      <DialogContent>
        <AddShareclassForm>
          {({ formState: { isValid, isSubmitting } }) => {
            return (
              <>
                <DialogHeader>
                  <DialogTitle>Add a new Shareclass</DialogTitle>
                </DialogHeader>
                <div className="my-6">
                  <AddShareclassFormFields />
                </div>
                <DialogFooter>
                  <Button
                    type="button"
                    variant={'destructive'}
                    size="sm"
                    onClick={() => props.onOpenChange?.(false)}
                  >
                    Cancel
                  </Button>
                  <SubmitButton
                    disabled={!isValid || isSubmitting}
                    loading={isSubmitting}
                    size="sm"
                  >
                    Submit
                  </SubmitButton>
                </DialogFooter>
              </>
            )
          }}
        </AddShareclassForm>
      </DialogContent>
    </Dialog>
  )
}
